import { setLocale } from 'yup';

setLocale({
    mixed: {
        required: (values) => ({ key: 'required', values }),
    },
});
